import { Component, Input } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-role]',
  template: `
    <td class="align-middle">{{role?.name?.name}}</td>
    <td class="align-middle">{{groups[role?.group_id - 1].name}}</td>
    <td class="align-middle text-end">
      <button class="btn btn-link" routerLink="{{role?.id}}" *ngIf="authService.hasPermission('can_edit_roles')">
        <fa-icon [icon]="icons.faEdit" size="1x" class="center-icon"></fa-icon>
      </button>
    </td>
  `,
  styles: ``
})
export class TrRoleComponent {
  @Input() role: any;

  groups: any[] = [
    { id: 1, name: 'Administradores' },
    { id: 2, name: 'Técnicos' },
    { id: 3, name: 'Inquilinos' },
  ];

  constructor(
    public icons: IconsService,
    public authService: AuthService
  ) { }
}
